import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import ratingQuery from '~/graphql/rating.gql';
const CONTEXT = 'http://schema.org';
const BRAND = 'Maisons du Monde';
const TYPE = 'Organization';
export default {
  name: 'RatingJsonLd',
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),

  head() {
    return {
      script: [{
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': CONTEXT,
          '@type': TYPE,
          name: BRAND,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: this.rating.value,
            ratingCount: this.rating.count,
            bestRating: '5.00'
          }
        })
      }]
    };
  },

  apollo: {
    rating: {
      query: ratingQuery,

      variables() {
        return {
          locale: this.locale.iso
        };
      }

    }
  },
  render: h => h(null)
};